import React from "react";
import { Chart } from "react-google-charts";

const ComboChart = (props) => {
  const options = {
    title: "Campaign Timeline",
    vAxis: { title: "Email Sent" },
    hAxis: { title: "Dates" },
    legend: { position: 'top', alignment: 'start' },
    seriesType: "bars",
    series: {0:{ type: "bars",  bar: { width: 40 } }, 1: { type: "line" }, 2:{type: "line"}, 3:{type: "line"},4:{type: "line"}, 5:{type: "line"}, 6:{type: "line"}, 7:{type: "line"} }, // Index 1 (Expenses) will be a line chart
  };
  const data = props.data;
  //console.log(props.data);
  return (
    <div style={{overflow:'scroll'}}>
      <Chart chartType="ComboChart" width={data.length > 10 ? 70 *data.length : '1000px'} height="400px" data={data} options={options} />      
    </div>
  );
};

export default ComboChart;